const url_prifix = "api/expenses-management";
export const EXPENSES_MASTER = `${url_prifix}/expenses/master`;
export const EXPENSES = `${url_prifix}/expenses`;
export const GET_EXPENSES_ID = `${url_prifix}/expenses/`;
export const GET_EXPENSES_PROCESSLIST = `${url_prifix}/expenses/process/list`;



